export enum NightGuardSubTypes {
  FlatOcclusalTypeId = 1,
  OcclusalAnteriorTypeId = 2,
  MichiganOcclusalTypeId = 9,
  FullCoverageAnteriorDeprogrammerTypeId = 10,
  DayguardTypeId = 11,
  RushFlatOcclusalTypeId = 68,
  RushOcclusalAnteriorTypeId = 69,
  RushMichiganOcclusalTypeId = 70,
  RushFullCoverageAnteriorDeprogrammerTypeId = 71,
  RushDayguardTypeId = 72,
}

export enum AINightGuardSubTypes {
  ClosedBite = 54,
  OpenBite = 55,
}
